import { ReportFormat } from "../classes/enums/ReportFormatEnum";

/**
 * Build the slim payload expected by the PrepareReportDigitalTwin validator.
 * Shape:
 * {
 *   clinicalNotes: string (can be empty),
 *   planIds: string[],
 *   haveDigitalTwin: boolean,
 *   haveCheck: boolean,
 *   haveAlign: boolean,
 *   format: ReportFormat (integer enum)
 * }
 */

/**
 * @param {Object} params
 * @param {Array<string>} params.selectedSections - Selected section names (upper-case keys)
 * @param {Array<Object>} params.selectedPlans - Selected plan objects
 * @param {string} params.clinicalNotes - Clinical notes / diagnostics text
 * @param {number} params.format - Output format (ReportFormat enum value)
 * @returns {Object} Payload for prepareReport
 */
export const buildReportPayload = ({
  selectedSections = [],
  selectedPlans = [],
  clinicalNotes = "",
  format = ReportFormat.WORD,
}) => {
  const selectedSectionSet = new Set(selectedSections);

  const haveDigitalTwin = selectedSectionSet.has("DIGITAL_TWIN");
  const haveCheck = selectedSectionSet.has("CHECK");
  const haveAlign = selectedSectionSet.has("ALIGN");

  const planIds = Array.from(
    new Set(
      (selectedPlans || [])
        .map(plan => plan?._id)
        .filter(id => typeof id === "string" && id.length > 0)
    )
  );

  return {
    clinicalNotes: clinicalNotes || "",
    planIds,
    haveDigitalTwin,
    haveCheck,
    haveAlign,
    format,
  };
};
